"use client";

import Image from "next/image";
const styles = new Proxy({"SensorVideo":"SensorVideo-cefaf","MovementSensorItem":"MovementSensorItem-cefaf","MovementSensorItemImg":"MovementSensorItemImg-cefaf","MovementSensorItemText":"MovementSensorItemText-cefaf","GetInTouch":"GetInTouch-cefaf","GetInTouchInner":"GetInTouchInner-cefaf","videoContainer":"videoContainer-cefaf"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import Section from "../Section";

const walking1 = "/images/walking_1.png";
const walking2 = "/images/walking_2.png";
const walking3 = "/images/walking_3.png";

type Card = {
  imgSrc: { url: string; width: number; height: number };
  imgAlt: string;
  imgWidth?: number;
  imgHeight?: number;
  description: string;
};

interface TextBubbleCardsClientProps {
  block: {
    title?: string;
    cards?: Card[];
  };
}

export const DEFAULT_CARDS: Card[] = [
  {
    imgSrc: { url: walking1, width: 600, height: 336 },
    imgAlt: "walking1",
    description:
      "The phone's gyroscope data, representing the rocking of the boat, is processed in real time",
  },
  {
    imgSrc: { url: walking2, width: 601, height: 339 },
    imgAlt: "walking2",
    description:
      "When the algorithm detects a capsize or a hard collision, it immediately notifies an emergency contact",
  },
  {
    imgSrc: { url: walking3, width: 600, height: 336 },
    imgAlt: "walking3",
    description:
      "A coach or an emergency response team receives the alert notification together with the Google map coordinates of the incident",
  },
];

export default function TextBubbleCardsClient({
  block,
}: TextBubbleCardsClientProps) {
  const { title, cards } = block;
  const usedCards = cards?.length ? cards : DEFAULT_CARDS;

  return (
    <Section title={title} className={styles.SensorVideo}>
      <div className="row my-5">
        <div className="col-lg-8 offset-lg-2">
          {usedCards.map((card, index) => (
            <div
              className={styles.MovementSensorItem}
              key={card.description || index}
            >
              <div className={styles.MovementSensorItemImg}>
                <Image
                  src={
                    card.imgSrc?.url
                      ? card.imgSrc.url.length > 0
                        ? card.imgSrc.url
                        : "/"
                      : "/"
                  }
                  alt={card.imgAlt || ""}
                  width={card.imgWidth || card.imgSrc?.width || 100}
                  height={card.imgHeight || card.imgSrc?.height || 100}
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
              <div className={styles.MovementSensorItemText}>
                <div>
                  <p>{card.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
